import React, { useEffect, useState } from 'react';
import api2 from '../../services/api2';
import Table from '../../components/Table';

function Movements() {
  const [movements, setMovements] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const columns = [
    {
      title: 'Conta',
      field: 'bill',
      hideFilterIcon: true,
      render: (rowData) => rowData.bill.description,
    },
    {
      title: 'Centro de Conta',
      field: 'accountCenter',
      hideFilterIcon: true,
      render: (rowData) => rowData.accountCenter.description,
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
    {
      title: 'Valor',
      field: 'value',
      hideFilterIcon: true,
      render: (rowData) => (
        <span>
          R$
          {new Intl.NumberFormat('pt-BR').format(rowData.value)}
        </span>
      ),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api2.get('/movements');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setMovements(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    movements.map((movement) => (movement.id === newData.id ? tempData.push(newData) : tempData.push(movement)));
    setMovements(tempData);
  }

  return (
    <Table
      title="Movimentações"
      route="/movements/"
      routeAdd="/movement/"
      columns={columns}
      data={movements}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Movements;
